import { Suspense } from 'react';

import Field from '@rewardopl/react-ui/field';

import { Wrapper } from './index.styles';

import LoadingText from '../../loading_text';
import MapComponent from './map';

type Location = [number, number];

type LocationFieldProps = {
  label?: React.ReactNode;
  name: string;
  onChange: (value: Location) => void;
  required?: boolean;
  value?: Location;
};

const defaultValue: Location = [19.145136, 51.919438];

export default function LocationField({
  label,
  name,
  onChange,
  required = true,
  value,
}: LocationFieldProps) {
  const valueWithDefault = value || defaultValue;

  return (
    <Field label={label} labelAndChildrenAs="div" labelAs="label" required={required}>
      <Wrapper>
        <Suspense fallback={<LoadingText />}>
          <MapComponent onChange={onChange} value={value} />
        </Suspense>
      </Wrapper>
      <input name={`${name}[0]`} type="hidden" value={valueWithDefault[0]} />
      <input name={`${name}[1]`} type="hidden" value={valueWithDefault[1]} />
    </Field>
  );
}
